// extracted by mini-css-extract-plugin
module.exports = {"root":"Calendar_root__1bmQB","customExternalEvent":"Calendar_customExternalEvent__1JAel"};